import { Button, Divider, Space } from '@mantine/core';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'wouter';
import { EmailLoginView } from './components/EmailLoginView';
import { LegalFooter } from './components/LegalFooter';
import { Page } from './components/Page';
import { PageCard } from './components/PageCard';
import { PageCardLogo } from './components/PageCardLogo';
import { SocialLoginView } from './components/SocialLoginView';
import { FakeLoginView } from './components/FakeLoginView';
import { useHostProperty } from './hooks/host';

const errorMessage = (code: string) => {
    switch (code) {
        case 'EXPIRED_TOKEN': return 'Your magic link has expired. Please request a new one.';
        case 'INVALID_TOKEN': return 'This magic link is no longer valid.';
        case 'ATTEMPTS_EXCEEDED': return 'Too many attempts on this link. Please request a new one.';
        default: return `We couldn't sign you in (${code}). Please request a new link.`;
    }
};

const readErrorFromUrl = () => {
    if (typeof window === 'undefined') return null;
    const params = new URLSearchParams(window.location.search);
    return params.get('error');
};

export const BoardLoginPage = () => {

    const accountLabel = useHostProperty('accountLabel') as string | undefined;
    const isProd = useHostProperty('env') === 'prod';
    const linkErrorCode = readErrorFromUrl();

    // Hack to make clicking logo go back to prev state (we're still on /login route)
    const [key, setKey] = useState(0);
    const onResetView = () => {
        setKey(key + 1);
    };

    return <Page variant="board">
        <PageCard>
            <PageCardLogo />
            <PageCard.Title>Sign in to open this board</PageCard.Title>
            {accountLabel &&
                <PageCard.Copy>
                    This board belongs to <span style={{ fontWeight: 500 }}>{accountLabel}</span> and is open only to members.
                </PageCard.Copy>
            }
            <Space h="md" />
            {linkErrorCode &&
                <>
                    <ErrorIntro>{errorMessage(linkErrorCode)}</ErrorIntro>
                    <Button component={Link} onClick={onResetView} href="/login" fullWidth>OK</Button>
                </>
            }
            {!linkErrorCode &&
                <EmailLoginView key={key}>
                    <Divider my="xl" label="or" labelPosition="center" />
                    <SocialLoginView />
                    {!isProd && <FakeLoginView />}
                </EmailLoginView>
            }
            <LegalFooter />
        </PageCard>
    </Page>;
};

const ErrorIntro = styled.p`
    font-size: 0.875rem;
    color: #b91c1c;
    margin: 0 0 1rem;
`;
